module.exports = __webpack_public_path__ + "static/media/footer-rectangle-2.b750cb84.svg";